/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var g = require("@lexical/html"),
    w = require("@lexical/link"),
    x = require("@lexical/mark"),
    I = require("@lexical/utils"),
    M = require("lexical"),
    N = require("react");

var O = Object.freeze({
  "\t": "\\t",
  "\n": "\\n"
}),
    P = new RegExp(Object.keys(O).join("|"), "g"),
    Q = Object.freeze({
  ancestorHasNextSibling: "|",
  ancestorIsLastChild: " ",
  hasNextSibling: "\u251C",
  isLastChild: "\u2514",
  selectedChar: "^",
  selectedLine: ">"
});

function R(a) {
  var _N$useState = N.useState([]),
      _N$useState2 = _slicedToArray(_N$useState, 2),
      b = _N$useState2[0],
      c = _N$useState2[1];

  N.useEffect(function () {
    var l = new Set();

    var _iterator = _createForOfIteratorHelper(a._commands),
        _step;

    try {
      var _loop = function _loop() {
        var _ref = _step.value;
        _ref2 = _slicedToArray(_ref, 1);
        var e = _ref2[0];
        l.add(a.registerCommand(e, function (p) {
          c(function (d) {
            d = _toConsumableArray(d);
            d.push({
              payload: p,
              type: e.type ? e.type : "UNKNOWN"
            });
            10 < d.length && d.shift();
            return d;
          });
          return !1;
        }, M.COMMAND_PRIORITY_HIGH));
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref2;

        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return function () {
      return l.forEach(function (e) {
        return e();
      });
    };
  }, [a]);
  return N.useMemo(function () {
    return b;
  }, [b]);
}

function U(a) {
  var b = "";
  var c = V(a);
  b += ": range ".concat("" !== c ? "{ ".concat(c, " }") : "", " ").concat("" !== a.style ? "{ style: ".concat(a.style, " } ") : "");
  c = a.anchor;
  a = a.focus;
  var l = c.offset,
      e = a.offset;
  b += "\n  \u251C anchor { key: ".concat(c.key, ", offset: ").concat(null === l ? "null" : l, ", type: ").concat(c.type, " }");
  return b += "\n  \u2514 focus { key: ".concat(a.key, ", offset: ").concat(null === e ? "null" : e, ", type: ").concat(a.type, " }");
}

function W(a, b, c) {
  var l = a.getEditorState(),
      e = a._config,
      p = a._compositionKey,
      d = a._editable;

  if (c) {
    var m = "";
    l.read(function () {
      var k = g.$generateHtmlFromNodes(a);
      var t = document.createElement("div");
      t.innerHTML = k.trim();
      m = X(t, 0).innerHTML;
    });
    return m;
  }

  var h = " root\n";
  c = l.read(function () {
    var m = M.$getSelection();
    Y(M.$getRoot(), function (k, t) {
      var y = "(".concat(k.getKey(), ")"),
          v = k.getType() || "",
          q = k.isSelected(),
          J = x.$isMarkNode(k) ? " id: [ ".concat(k.getIDs().join(", "), " ] ") : "";
      var A = h,
          H = q ? Q.selectedLine : " ",
          F = t.join(" ");

      if (M.$isTextNode(k)) {
        var n = k.getTextContent();
        var u = 0 === n.length ? "(empty)" : "\"".concat(Z(n), "\"");
        n = [V(k), aa(k), ba(k)].filter(Boolean).join(", ");
        n = [u, 0 !== n.length ? "{ ".concat(n, " }") : null].filter(Boolean).join(" ").trim();
      } else if (w.$isLinkNode(k)) {
        n = k.getURL();
        n = 0 === n.length ? "(empty)" : "\"".concat(Z(n), "\"");
        u = k.getTarget();
        null != u && (u = "target: " + u);
        var B = Boolean;
        var C = k.getRel();
        null != C && (C = "rel: " + C);
        var r = k.getTitle();
        null != r && (r = "title: " + r);
        u = [u, C, r].filter(B).join(", ");
        n = [n, 0 !== u.length ? "{ ".concat(u, " }") : null].filter(Boolean).join(" ").trim();
      } else n = "";

      h = A + "".concat(H, " ").concat(F, " ").concat(y, " ").concat(v, " ").concat(J, " ").concat(n, "\n");
      h += ca({
        indent: t,
        isSelected: q,
        node: k,
        nodeKeyDisplay: y,
        selection: m,
        typeDisplay: v
      });
    });
    return null === m ? ": null" : M.$isRangeSelection(m) ? U(m) : M.DEPRECATED_$isGridSelection(m) ? ": grid\n  \u2514 { grid: ".concat(m.gridKey, ", anchorCell: ").concat(m.anchor.key, ", focusCell: ").concat(m.focus.key, " }") : ": node\n  \u2514 [".concat(Array.from(m._nodes).join(", "), "]");
  });
  h += "\n selection" + c;
  h += "\n\n commands:";

  if (b.length) {
    var _iterator2 = _createForOfIteratorHelper(b),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _ref4 = _step2.value;
        var _m = _ref4.type;
        var k = _ref4.payload;
        h += "\n  \u2514 { type: ".concat(_m, ", payload: ").concat(k instanceof Event ? k.constructor.name : k, " }");
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } else h += "\n  \u2514 None dispatched.";

  h += "\n\n editor:";
  h += "\n  \u2514 namespace ".concat(e.namespace);
  null !== p && (h += "\n  \u2514 compositionKey ".concat(p));
  return h += "\n  \u2514 editable ".concat(String(d));
}

function Y(a, b) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  a = a.getChildren();
  var l = a.length;
  a.forEach(function (e, p) {
    b(e, c.concat(p === l - 1 ? Q.isLastChild : Q.hasNextSibling));
    M.$isElementNode(e) && Y(e, b, c.concat(p === l - 1 ? Q.ancestorIsLastChild : Q.ancestorHasNextSibling));
  });
}

function Z(a) {
  return Object.entries(O).reduce(function (b, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        c = _ref6[0],
        l = _ref6[1];

    return b.replace(new RegExp(c, "g"), String(l));
  }, a);
}

var da = [function (a) {
  return a.hasFormat("bold") && "Bold";
}, function (a) {
  return a.hasFormat("code") && "Code";
}, function (a) {
  return a.hasFormat("italic") && "Italic";
}, function (a) {
  return a.hasFormat("strikethrough") && "Strikethrough";
}, function (a) {
  return a.hasFormat("subscript") && "Subscript";
}, function (a) {
  return a.hasFormat("superscript") && "Superscript";
}, function (a) {
  return a.hasFormat("underline") && "Underline";
}],
    ea = [function (a) {
  return a.isDirectionless() && "Directionless";
}, function (a) {
  return a.isUnmergeable() && "Unmergeable";
}],
    fa = [function (a) {
  return a.isToken() && "Token";
}, function (a) {
  return a.isSegmented() && "Segmented";
}];

function aa(a) {
  var b = ea.map(function (c) {
    return c(a);
  }).filter(Boolean).join(", ").toLocaleLowerCase();
  "" !== b && (b = "detail: " + b);
  return b;
}

function ba(a) {
  var b = fa.map(function (c) {
    return c(a);
  }).filter(Boolean).join(", ").toLocaleLowerCase();
  "" !== b && (b = "mode: " + b);
  return b;
}

function V(a) {
  var b = da.map(function (c) {
    return c(a);
  }).filter(Boolean).join(", ").toLocaleLowerCase();
  "" !== b && (b = "format: " + b);
  return b;
}

function ca(_ref7) {
  var a = _ref7.indent,
      b = _ref7.isSelected,
      c = _ref7.node,
      l = _ref7.nodeKeyDisplay,
      e = _ref7.selection,
      p = _ref7.typeDisplay;
  if (!M.$isTextNode(c) || !M.$isRangeSelection(e) || !b || M.$isElementNode(c)) return "";
  b = e.anchor;
  var d = e.focus;
  if ("" === c.getTextContent() || b.getNode() === e.focus.getNode() && b.offset === d.offset) return "";
  d = e.anchor;
  var h = e.focus,
      m = c.getTextContent(),
      k = m.length;
  b = e = -1;

  if ("text" === d.type && "text" === h.type) {
    var _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14;

    var v = d.getNode(),
        q = h.getNode();
    v === q && c === v && d.offset !== h.offset ? (_ref8 = d.offset < h.offset ? [d.offset, h.offset] : [h.offset, d.offset], _ref9 = _slicedToArray(_ref8, 2), e = _ref9[0], b = _ref9[1], _ref8) : c === v ? (_ref10 = v.isBefore(q) ? [d.offset, k] : [0, d.offset], _ref11 = _slicedToArray(_ref10, 2), e = _ref11[0], b = _ref11[1], _ref10) : c === q ? (_ref12 = q.isBefore(v) ? [h.offset, k] : [0, h.offset], _ref13 = _slicedToArray(_ref12, 2), e = _ref13[0], b = _ref13[1], _ref12) : (_ref14 = [0, k], e = _ref14[0], b = _ref14[1], _ref14);
  }

  c = (m.slice(0, e).match(P) || []).length;
  d = (m.slice(e, b).match(P) || []).length;
  var t = e + c,
      y = b + c + d;
  if (t === y) return "";
  c = a[a.length - 1] === Q.hasNextSibling ? Q.ancestorHasNextSibling : Q.ancestorIsLastChild;
  a = [].concat(_toConsumableArray(a.slice(0, a.length - 1)), [c]);
  c = Array(t + 1).fill(" ");
  e = Array(y - t).fill(Q.selectedChar);
  l = Array(l.length + (p.length + 3)).fill(" ");
  return [Q.selectedLine, a.join(" "), [].concat(_toConsumableArray(l), _toConsumableArray(c), _toConsumableArray(e)).join("")].join(" ") + "\n";
}

function X(a, b) {
  var c = Array(b++ + 1).join("  "),
      l = Array(b - 1).join("  "),
      e;

  for (var p = 0; p < a.children.length; p++) {
    e = document.createTextNode("\n" + c), a.insertBefore(e, a.children[p]), X(a.children[p], b), a.lastElementChild === a.children[p] && (e = document.createTextNode("\n" + l), a.appendChild(e));
  }

  return a;
}

exports.TreeView = function (_ref15) {
  var a = _ref15.treeTypeButtonClassName,
      b = _ref15.timeTravelButtonClassName,
      c = _ref15.timeTravelPanelSliderClassName,
      l = _ref15.timeTravelPanelButtonClassName,
      e = _ref15.viewClassName,
      p = _ref15.timeTravelPanelClassName,
      d = _ref15.editor;

  var _N$useState3 = N.useState([]),
      _N$useState4 = _slicedToArray(_N$useState3, 2),
      h = _N$useState4[0],
      m = _N$useState4[1],
      _N$useState5 = N.useState(""),
      _N$useState6 = _slicedToArray(_N$useState5, 2),
      k = _N$useState6[0],
      t = _N$useState6[1],
      _N$useState7 = N.useState(!1),
      _N$useState8 = _slicedToArray(_N$useState7, 2),
      y = _N$useState8[0],
      v = _N$useState8[1],
      _N$useState9 = N.useState(!1),
      _N$useState10 = _slicedToArray(_N$useState9, 2),
      q = _N$useState10[0],
      J = _N$useState10[1],
      A = N.useRef(0),
      H = N.useRef(null),
      F = N.useRef(null),
      _N$useState11 = N.useState(!1),
      _N$useState12 = _slicedToArray(_N$useState11, 2),
      n = _N$useState12[0],
      u = _N$useState12[1],
      _N$useState13 = N.useState(!1),
      _N$useState14 = _slicedToArray(_N$useState13, 2),
      B = _N$useState14[0],
      C = _N$useState14[1],
      _N$useState15 = N.useState(!1),
      _N$useState16 = _slicedToArray(_N$useState15, 2),
      r = _N$useState16[0],
      ha = _N$useState16[1],
      K = N.useRef(null),
      D = R(d),
      L = N.useCallback(function (f) {
    var z = W(d, D, q);
    t(z);
    y || m(function (G) {
      return [].concat(_toConsumableArray(G), [[Date.now(), f]]);
    });
  }, [D, d, y, q]);

  N.useEffect(function () {
    var f = d.getEditorState();
    !r && 1E3 > f._nodeMap.size && t(W(d, D, q));
  }, [D, d, r, q]);
  N.useEffect(function () {
    return I.mergeRegister(d.registerUpdateListener(function (_ref16) {
      var f = _ref16.editorState;
      if (!r && 1E3 < f._nodeMap.size && (K.current = f, C(!0), !r)) return;
      L(f);
    }), d.registerEditableListener(function () {
      var f = W(d, D, q);
      t(f);
    }));
  }, [D, d, q, B, L, r]);
  var E = h.length;
  N.useEffect(function () {
    if (n) {
      var f,
          z = function z() {
        var G = A.current;
        G === E - 1 ? u(!1) : f = setTimeout(function () {
          A.current++;
          var S = A.current,
              T = F.current;
          null !== T && (T.value = String(S));
          d.setEditorState(h[S][1]);
          z();
        }, h[G + 1][0] - h[G][0]);
      };

      z();
      return function () {
        clearTimeout(f);
      };
    }
  }, [h, n, d, E]);
  N.useEffect(function () {
    var f = H.current;
    if (null !== f) return f.__lexicalEditor = d, function () {
      f.__lexicalEditor = null;
    };
  }, [d]);
  return N.createElement("div", {
    className: e
  }, !r && B ? N.createElement("div", {
    style: {
      padding: 20
    }
  }, N.createElement("span", {
    style: {
      marginRight: 20
    }
  }, "Detected large EditorState, this can impact debugging performance."), N.createElement("button", {
    onClick: function onClick() {
      ha(!0);
      var f = K.current;
      null !== f && (K.current = null, L(f));
    },
    style: {
      background: "transparent",
      border: "1px solid white",
      color: "white",
      cursor: "pointer",
      padding: 5
    }
  }, "Show full tree")) : null, r ? null : N.createElement("button", {
    onClick: function onClick() {
      return J(!q);
    },
    className: a,
    type: "button"
  }, q ? "Tree" : "Export DOM"), !y && (r || !B) && 2 < E && N.createElement("button", {
    onClick: function onClick() {
      var f = d.getRootElement();
      null !== f && (f.contentEditable = "false", A.current = E - 1, v(!0));
    },
    className: b,
    type: "button"
  }, "Time Travel"), (r || !B) && N.createElement("pre", {
    ref: H
  }, k), y && (r || !B) && N.createElement("div", {
    className: p
  }, N.createElement("button", {
    className: l,
    onClick: function onClick() {
      A.current === E - 1 && (A.current = 1);
      u(!n);
    },
    type: "button"
  }, n ? "Pause" : "Play"), N.createElement("input", {
    className: c,
    ref: F,
    onChange: function onChange(f) {
      f = Number(f.target.value);
      var z = h[f];
      z && (A.current = f, d.setEditorState(z[1]));
    },
    type: "range",
    min: "1",
    max: E - 1
  }), N.createElement("button", {
    className: l,
    onClick: function onClick() {
      var f = d.getRootElement();

      if (null !== f) {
        f.contentEditable = "true";
        f = h.length - 1;
        d.setEditorState(h[f][1]);
        var z = F.current;
        null !== z && (z.value = String(f));
        v(!1);
        u(!1);
      }
    },
    type: "button"
  }, "Exit")));
};